import { Container, Navbar } from "react-bootstrap"
import { CreateAuditOffcanvass } from "./CreateAuditOffcanvas"
import MainNavbar from "./MainNavbar"
import PersonDropdown from "./PersonDropdown"
import { useState } from "react"

export const TypicalPageStructure = ({ children, pageLabel }) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <>
            <Navbar expand="lg" className="main-header" expanded={expanded}>
                <Container>
                    <MainNavbar/>
                    <PersonDropdown/>
                </Container>
            </Navbar>
                {/* <MainNavbar/>
                <div style={{display:"flex"}}>
                    <div className="me-1">
                    <CreateAuditOffcanvass/>
                    </div>
                    <div className="ms-1">
                    <PersonDropdown/>
                    </div>
                </div> */}
            <div className="container mt-2">
                <div >
                    <div className="mb-2 mt-3">
                        <h3>{pageLabel}</h3>
                    </div>
                    {children}
                </div>
            </div>
        </>
    ) 
}